import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        premiumType: [
          !!entity?.parameters?.guarantees?.length &&
          !!entity?.parameters?.guarantees?.[0]?.premiumType
            ? entity?.parameters?.guarantees?.[0]?.premiumType
            : 'CI',
          [Validators.required],
        ],
        guarantees: this.formBuilder.array(
          entity?.parameters?.guarantees &&
            entity?.parameters?.guarantees.length
            ? entity?.parameters?.guarantees.map(guarantee =>
                this.formBuilder.group({
                  ownerId: [guarantee.ownerId],
                  quotite: [guarantee.quotite],
                  dcPtia: this.formBuilder.group({
                    enabled: [guarantee.dcPtia.enabled || false],
                    required: [
                      guarantee.dcPtia.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.dcPtia.code || 'DCPTIA'],
                    type: [guarantee.dcPtia.type || 'COVERAGE'],
                    deductible: [guarantee.dcPtia.deductible || null],
                    typeReglement: [guarantee.dcPtia.typeReglement || null],
                    quotite: [guarantee.dcPtia.quotite || guarantee.quotite],
                  }),
                  ipt: this.formBuilder.group({
                    enabled: [guarantee.ipt.enabled || false],
                    required: [
                      guarantee.ipt.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.ipt.code || 'IPT'],
                    type: [guarantee.ipt.type || 'COVERAGE'],
                    deductible: [guarantee.ipt.deductible || null],
                    typeReglement: [guarantee.ipt.typeReglement || 'RENTE'],
                    quotite: [guarantee.ipt.quotite || guarantee.quotite],
                  }),
                  ipp: this.formBuilder.group({
                    enabled: [guarantee.ipp.enabled || false],
                    required: [
                      guarantee.ipp.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.ipp.code || 'IPP'],
                    type: [guarantee.ipp.type || 'COVERAGE'],
                    deductible: [guarantee.ipp.deductible || null],
                    typeReglement: [guarantee.ipp.typeReglement || null],
                    quotite: [guarantee.ipp.quotite || guarantee.quotite],
                  }),
                  pe: this.formBuilder.group({
                    enabled: [guarantee.pe.enabled || false],
                    required: [
                      guarantee.pe.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.pe.code || 'PE'],
                    type: [guarantee.pe.type || 'COVERAGE'],
                    deductible: [guarantee.pe.deductible || null],
                    typeReglement: [guarantee.pe.typeReglement || null],
                    quotite: [guarantee.pe.quotite || guarantee.quotite],
                  }),
                  ipm: this.formBuilder.group({
                    enabled: [guarantee.ipm.enabled || false],
                    required: [
                      guarantee.ipm.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.ipm.code || 'IPM'],
                    type: [guarantee.ipm.type || 'COVERAGE'],
                    deductible: [guarantee.ipm.deductible || null],
                    typeReglement: [guarantee.ipm.typeReglement || null],
                    quotite: [guarantee.ipm.quotite || guarantee.quotite],
                  }),
                  itt: this.formBuilder.group({
                    enabled: [guarantee.itt.enabled || false],
                    required: [
                      guarantee.itt.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.itt.code || 'ITT'],
                    type: [guarantee.itt.type || 'COVERAGE'],
                    deductible: [
                      guarantee.itt.deductible || 'QUATRE_VINGT_DIX',
                    ],
                    typeReglement: [guarantee.itt.typeReglement || null],
                    quotite: [guarantee.itt.quotite || guarantee.quotite],
                  }),
                  octc: this.formBuilder.group({
                    enabled: [guarantee.octc.enabled || false],
                    required: [
                      guarantee.octc.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.octc.code || 'OCTC'],
                    type: [guarantee.octc.type || 'OPTION'],
                    deductible: [guarantee.octc.deductible || null],
                    typeReglement: [guarantee.octc.typeReglement || null],
                    quotite: [guarantee.octc.quotite || guarantee.quotite],
                  }),
                  dosPsy: this.formBuilder.group({
                    enabled: [guarantee.dosPsy.enabled || false],
                    required: [
                      guarantee.dosPsy.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.dosPsy.code || 'DOS_PSY'],
                    type: [guarantee.dosPsy.type || 'OPTION'],
                    deductible: [guarantee.dosPsy.deductible || null],
                    typeReglement: [guarantee.dosPsy.typeReglement || null],
                    quotite: [guarantee.dosPsy.quotite || guarantee.quotite],
                  }),
                  senior: this.formBuilder.group({
                    enabled: [guarantee.senior.enabled || false],
                    required: [
                      guarantee.senior.required || false,
                      Validators.required,
                    ],
                    code: [guarantee.senior.code || 'SENIOR'],
                    type: [guarantee.senior.type || 'OPTION'],
                    deductible: [guarantee.senior.deductible || null],
                    typeReglement: [guarantee.senior.typeReglement || null],
                    quotite: [guarantee.senior.quotite || guarantee.quotite],
                  }),
                  premiumType: [
                    guarantee.premiumType || 'CI',
                    [Validators.required],
                  ],
                }),
              )
            : [],
        ),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const products = _.cloneDeep(this.form.value.products);

    products.forEach(product => {
      product.parameters.guarantees.forEach(guarantee => {
        guarantee.premiumType = product.parameters.premiumType || 'CI';
      });
      delete product.parameters.premiumType;
    });

    return products;
  }
}
